"use client";

import { BlogNotFound } from "@/app/blog/components/NotFound";

import { usePathname } from "next/navigation";

const NotFound = () => {
  const pathname = usePathname();

  if (pathname.startsWith("/blog")) {
    return <BlogNotFound />;
  }

  return (
    <main>
      <div className="not-found__box">
        <h1>404</h1>
        <h2>Page not found</h2>
      </div>
    </main>
  );
};

export default NotFound;
